/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "loading-label": [{
    "type": 0,
    "value": "Chargement en cours"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var frCA = Object.assign(TranslationProviderComponent, {
  translations
});

export { frCA as f };
//# sourceMappingURL=fr-CA-DLcc87vY.js.map
